import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link } from "gatsby";

const RelatedPosts = ({ strapiArticle, articlesArray }) => {

    const similarArticles = _fetchSimilarArticles(
        strapiArticle,
        articlesArray
      );
    
      const isBrowser = typeof window !== "undefined";
    
      function _fetchSimilarArticles(currentArticleData, allArticles) {
        var articleArray = [];
        allArticles.forEach(function (articleNode) {
          if (
            currentArticleData.strapi_id !== articleNode.strapi_id &&
            articleNode.articleCategory.strapi_id !== 11
          ) {
            //const customTagIntersection = currentArticleData.customTags.filter(element => articleNode.customTags.includes(element));
            const catTagIntersection = currentArticleData.categoryTag.filter(
              (element) => articleNode.categoryTag.includes(element)
            );
            const subCatTagIntersection = currentArticleData.subCategoryTags.filter(
              (element) => articleNode.subCategoryTags.includes(element)
            );
            const listingTagIntersection = currentArticleData.productTags.filter(
              (element) => articleNode.productTags.includes(element)
            );
            var score =
              catTagIntersection.length +
              subCatTagIntersection.length +
              listingTagIntersection.length; // customTagIntersection.length;
            articleNode["score"] = score;
            articleArray.push(articleNode);
          }
        });
        articleArray.sort((a, b) => b["score"] - a["score"]);
    
        return articleArray.slice(0, 5);
      }

  return (
    <>
    <Typography
      variant="h2Side"
      sx={{
        ml: 4,
        mt: 5,
        mb: 3,
        mr: 4,
        color: "#606C7F",
        fontSize: "1.6rem",
        textAlign: "center",
        display: "block",
      }}
    >
      Related Posts
    </Typography>
    {similarArticles.map((article, index) => (
      <Grid item xs={"auto"}>
        {isBrowser
          ? window.dataLayer.push({
              event: "content_view",
              Author_Name: article.authors[0].name,
              Content_Name: article.title,
              block: "article_side_bar",
            })
          : ""}
        <Card
          display="flex"
          sx={{ borderRadius: 5, boxShadow: 1, mt: 2 }}
        >
          <Divider
            orientation="vertical"
            sx={{
              color: "#a3bffa",
              height: "100%",
              width: "5px",
            }}
          />
          <Grid
            container
            item
            xs
            direction="row"
            spacing={0}
            alignItems="stretch"
            justifyContent="flex-start"
          >
            <Grid item xs={1}>
              <Divider
                orientation="vertical"
                sx={{
                  backgroundColor: "#a3bffa",
                  height: "100%",
                  width: "5px",
                }}
              />
            </Grid>
            <Grid
              item
              xs={10}
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Box sx={{ pt: 2, pb: 1 }}>
                <Grid
                  container
                  columnSpacing={2}
                  rowSpacing={2}
                  direction="row"
                >
                  <Grid item>
                    <Link
                      id={"libraryArticleSide" + index}
                      to={article.path}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <Typography
                        variant="h7press"
                        sx={{
                          cursor: "pointer",
                          display: "block",
                        }}
                      >
                        {article.title}
                      </Typography>
                    </Link>
                  </Grid>
                </Grid>
              </Box>
              <Grid
                item
                container
                direction="row"
                columnSpacing={2}
                sx={{ pb: 1 }}
              >
                <Grid item>
                  {article.authors.map(
                    (author, authorIndex) => (
                      <Typography
                        variant="h10N"
                        sx={{ cursor: "pointer" }}
                      >
                        {authorIndex === 0 ? (
                          <>
                            <Link
                              id={
                                "libraryArticleAuthor" + index
                              }
                              to={author.path}
                              style={{
                                textDecoration: "none",
                                color: "#4F5968",
                              }}
                            >
                              {author.name}
                            </Link>
                          </>
                        ) : (
                          <>
                            {
                              (authorIndex = 1 ? (
                                <>
                                  <Link
                                    to={article.path}
                                    style={{
                                      textDecoration: "none",
                                      color: "#4F5968",
                                      marginLeft: 4,
                                    }}
                                  >
                                    et al.
                                  </Link>
                                </>
                              ) : (
                                ""
                              ))
                            }
                          </>
                        )}
                      </Typography>
                    )
                  )}
                </Grid>
                <Grid item>
                  <Typography variant="h10N">
                    {article.updatedAt}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    ))}
  </>
  );
};
export default RelatedPosts;
